@if (company === null) {
    <splash></splash>
}
@else {
    @if (showContents) {

        @if (!loading) {
            <div class="cover" [class.signing]="isUserGuest">
                @if (isUserGuest) {
                    <app-language-switcher mode="dropdown"></app-language-switcher>
                }
                @else {
                    <app-header></app-header>
                }
                <div [ngClass]="{
                    'container-fluid': !isUserGuest,
                    'container-lg py-1 py-sm-3 py-md-5 cover-container': isUserGuest,
                    'default': !company?.id || company?.primary
                }">
                    <ng-container *ngTemplateOutlet="routing"></ng-container>
                </div>
            </div>
        }

        <modal-terms (onClose)="showInstructions = true"></modal-terms>
        @if (showInstructions && (!company || company?.primary)) {
            <modal-instructions></modal-instructions>
        }
    }
    @else {
        <ng-container *ngTemplateOutlet="routing"></ng-container>
    }
}
<p-toast></p-toast>

<ng-template #routing>
    <router-outlet></router-outlet>
</ng-template>

@if (showRefreshAskModal) {
    <modal-confirm  (onAction)="onModalRefresh($event)"
                    [closable]="false"
                    body=""
    >
        <p class="mt-4">{{ 'Системата е обновена с нова версия. Желаете ли презареждане на страницата?' | transloco }}</p>
    </modal-confirm>
}
